import { useEffect, useState } from "react";
import { getNotifications, updateNotifications } from "@lib";
import { introspectionAPI } from "@lib";
import { messages } from "../../../src/resources/strings";
import { useAppSelector } from "@lib";
import { notificationTapHandler } from "@lib/utilities/notificationHelper/NotificationTapHandler";
import { useAuth0 } from "@auth0/auth0-react";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { ScreenNameList } from "@lib/utilities/Constants";
import { Dimensions, Platform } from "react-native";

export const useNotification = (props: any) => {
  const { logout } = useAuth0();
  const [notificationList, setNotificationList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [errorHandle, setErrorHandle] = useState(messages.error.noError);
  const policies = useAppSelector((state) => state.policyReducer.policies);

  const [orientation, setOrientation] = useState(
    Dimensions.get("window").width > Dimensions.get("window").height
      ? "LANDSCAPE"
      : "PORTRAIT"
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      const { width, height } = Dimensions.get("window");
      setOrientation(width > height ? "LANDSCAPE" : "PORTRAIT");
    };
    handleOrientationChange();
    const subscription = Dimensions.addEventListener(
      "change",
      handleOrientationChange
    );
    return () => subscription?.remove();
  }, []);

  const callIntrospectionAndGetNotificationApi = async () => {
    setLoading(true);
    const introspectionResponse = await introspectionAPI();
    if (introspectionResponse.response) {
      getAllNotifications();
    } else if (introspectionResponse.errorCode == messages.error.networkError) {
      setLoading(false);
      showInternetalert();
    } else {
      // refresh token
      setLoading(false);
      props.closeNotificationCenter();
      setErrorHandle(messages.error.resetPasswordLogout);
    }
  };

  //API :: Call api and set response ::
  const getAllNotifications = async () => {
    const responseObj = await getNotifications();
    if (responseObj.errorCode == messages.error.noError) {
      // Ensure unique notifications by using Set with a unique identifier (id)
      const uniqueNotifications: any = Array.from(
        new Map(
          responseObj.response.map((item: any) => [item.id, item])
        ).values()
      );
      setNotificationList(uniqueNotifications);
      setErrorHandle(responseObj.errorCode);
    } else if (responseObj.errorCode == messages.error.networkError) {
      showInternetalert();
      setNotificationList([]);
    } else if (responseObj.errorCode == messages.error.noData) {
      setErrorHandle(messages.error.noNotificationFound);
      setNotificationList([]);
    } else {
      setErrorHandle(responseObj.errorCode);
      setNotificationList([]);
    }
    setLoading(false);
  };

  // On selecting choose policy item ::
  const onNotificationItemClick = async (notificationObject: any) => {
    //Update notification read flag
    if (notificationObject.isRead === false) {
      updateNotifications(true, notificationObject.id);
    }
    setTimeout(() => {
      //Close notification center
      props.closeNotificationCenter();
    }, 50);

    //Navigate on tap handle
    const object = { data: notificationObject };

    // TO-DO :: Handle navigation on notification tap :: NEW IMPLAMENTATION 
    // notificationTapHandler(object, policies);
  };

  // Reload error alert ::
  const onReloadPress = async () => {
    callIntrospectionAndGetNotificationApi();
  };

  const getTimer = () => {
    return Platform.OS == "web" ? 100 : 20;
  };

  const showInternetalert = async () => {
    setErrorHandle(messages.error.noError);
    setTimeout(() => {
      setErrorHandle(messages.error.youAreOffline);
    }, getTimer());
  };

  const handleInvalidTokenCase = () => {
    clearSessionAndLogout(props.navigation, logout);
    props.closeNotificationCenter();
  };

  useEffect(() => {
    if (props?.isNotificationCenterVisible) {
      callIntrospectionAndGetNotificationApi();
    }
  }, [props?.isNotificationCenterVisible]);
  const errorData = {
    message:
      errorHandle == messages.error.sessionExpired ||
      errorHandle == messages.error.resetPasswordLogout
        ? errorHandle
        : messages.error.noError,
    screenName: ScreenNameList.notificationCenter,
  };

  return {
    errorData,
    onNotificationItemClick,
    onReloadPress,
    handleInvalidTokenCase,
    isLoading,
    notificationList,
    errorHandle,
    setErrorHandle,
    orientation,
  };
};
